import QRCode from "react-qr-code";
import { ReactComponent as CopyBold } from "../../../assets/icons/depositCrypto/depostCopyBold.svg";
import { useTranslation } from "react-i18next";
import Button from "../../../components/button/Button";
import { getCourse } from "../../Deposit/depositBank/depostBankUtils";
import { useEffect, useState } from "react";
import axios from "axios";
const ReplenishmentDetailsComponent = ({
  depositAddress,
  bankTransferREKS,
  walletbk,
  handleCopy,
  handleConfirmPayment,
  showConfirmButton,
  summ,
  qrCodeImage
}) => {
  const { t } = useTranslation();
  const [cursCb, setCursCb] = useState(0)

  useEffect(() => {
    axios
      .get(`https://api-ru.fynex.cc/api/api/current_coin/ruble`)
      .then((res) => {
        setCursCb(Math.floor(res.data * summ));
      });
  }, []);
  


  return (
    <div className="ReplenishmentDetails">
      <h2>{t("depositBank.title")}</h2>
      <div className="inputBlock">
        {/* <QRCode value={depositAddress} className="qrcodeBank" />123 */}
        {
          qrCodeImage == "" || qrCodeImage == null || qrCodeImage == undefined ? 
          <svg xmlns="http://www.w3.org/2000/svg" fill="#000000" width="253px" height="253px" viewBox="0 0 24.00 24.00" id="qr-code-scan" data-name="Flat Line" className="icon flat-line" > <g id="SVGRepo_iconCarrier"> <path id="secondary" d="M13,11V7h4v4ZM7,13v4h4V13Z" style={{ fill: "#3BE8A2", strokeWidth: "0.672" }} /> <path id="primary" d="M13,11V7h4v4Zm4,6V15H15v2ZM7,13v4h4V13ZM7,7V9H9V7Z" style={{ fill: "none", stroke: "#ffffff", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "0.672" }} /> <path id="primary-2" data-name="primary" d="M21,8V4a1,1,0,0,0-1-1H16" style={{ fill: "none", stroke: "#ffffff", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "0.672" }} /> <path id="primary-3" data-name="primary" d="M16,21h4a1,1,0,0,0,1-1V16" style={{ fill: "none", stroke: "#ffffff", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "0.672" }} /> <path id="primary-4" data-name="primary" d="M8,3H4A1,1,0,0,0,3,4V8" style={{ fill: "none", stroke: "#ffffff", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "0.672" }} /> <path id="primary-5" data-name="primary" d="M3,16v4a1,1,0,0,0,1,1H8" style={{ fill: "none", stroke: "#ffffff", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "0.672" }} /> </g> </svg>
          :
          <img className="qrcodeBank" src={qrCodeImage} alt="" />
        }
        <div className="InputContainer">
          <div className="input inputQrcode">
            <p>{t("depositBank.recipientBank")}</p>
            <div className="copyWrapper">
              <div className="textarea">{bankTransferREKS.bank}</div>
              {/* <input value={bankTransferREKS.bank} disabled type="text" /> */}
              <div className="wrapperSvg">
                <CopyBold onClick={() => handleCopy(bankTransferREKS.bank)} />
              </div>
            </div>
          </div>

          <div className="input inputQrcode">
            <p>{t("depositBank.recipientName")}</p>
            <div className="copyWrapper">
              <div className="textarea">{bankTransferREKS.name}</div>
              {/* <input value={bankTransferREKS.name} disabled type="text" /> */}
              <div className="wrapperSvg">
                <CopyBold onClick={() => handleCopy(bankTransferREKS.name)} />
              </div>
            </div>
          </div>

          <div className="input inputQrcode">
            <p>{t("depositBank.recipientCardNumber")}</p>
            <div className="copyWrapper">
              <div className="textarea">{walletbk}</div>
              {/* <input value={walletbk} type="text" disabled /> */}
              <div className="wrapperSvg">
                <CopyBold onClick={() => handleCopy(walletbk)} />
              </div>
            </div>
          </div>

          {bankTransferREKS.comment != "" && (
            <div className="input inputQrcode">
              <p>{t("depositBank.comment")}</p>
              <div className="copyWrapper">
                <div className="textarea">{bankTransferREKS.comment}</div>
                {/* <input value={bankTransferREKS.comment} type="text" disabled /> */}
                <div className="wrapperSvg">
                  <CopyBold
                    onClick={() => handleCopy(bankTransferREKS.comment)}
                  />
                </div>
              </div>
            </div>
          )}

          <div className="input inputQrcode">
            <p>{t("transactions.amount")}</p>
            <div className="copyWrapper">
              <div className="textarea">{cursCb}</div>
              {/* <input value={cursCb} type="text" disabled /> */}
              <div className="wrapperSvg">
                <CopyBold onClick={() => handleCopy(cursCb)} />
              </div>
            </div>
          </div>
        </div>
      </div>
      <p className="pReplen">{t("depositBank.checkDetails")}</p>
      <Button onClick={handleConfirmPayment} text={t("depositBank.confirm")} />
    </div>
  );
};

export default ReplenishmentDetailsComponent;
